export default __webpack_public_path__ + "static/media/password.e69b902a.svg";